import { useState, useEffect } from 'react'
import '../Css_files/About_c1.css'

function Hero() {
  const [currentText, setCurrentText] = useState(0)
  const textArray = [
    "Welcome to Profenaa Technologies",
    "Empowering Your Tech Journey",
    "Building Tomorrow's Developers"
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % textArray.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="hero-container">
      <div className="hero-content">
        <div className="hero-logo">
          <div className="logo-animation">PT</div>
        </div>
        <h1 className="hero-title">
          <span className="typing-text">{textArray[currentText]}</span>
        </h1>
        <p className="hero-subtitle">
          Leading IT Training Institute - Transforming Careers Through Technology Education
        </p>
        {/* <div className="hero-stats">
          <div className="stat">
            <span className="stat-number">5000+</span>
            <span className="stat-label">Students Trained</span>
          </div>
          <div className="stat">
            <span className="stat-number">50+</span>
            <span className="stat-label">Courses</span>
          </div>
          <div className="stat">
            <span className="stat-number">95%</span>
            <span className="stat-label">Placement Rate</span>
          </div>
        </div> */}
      </div>
      <div className="hero-background-animation">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>
    </div>
  )
}

export default Hero